<bp-send-reset-password-link-form
	class="h-100"
	[pending]="introFacade.pending$ | async"
	[error]="introFacade.error$ | async"
	(submitted)="identityFacade.sendResetPasswordLink($event)"
	(login)="introFacade.gotoLoginPage()"
>
</bp-send-reset-password-link-form>
